.container {
    display: flex;
    justify-self: flex-end;
    width: fit-content;
}

.container input[type='radio'] {
    display: none;
}

.label-container {
    display: flex;
}

.label {
    margin-left: 6px;
}
